import baseColorsLightByShade from '@/plugins/colors/base/baseColorsLight'
import lightTokens from '@/plugins/colors/tokens/light'


export const lightThemeTokens = {
  ...baseColorsLightByShade,
  ...lightTokens
}